<template>
  <div>
    <div class="row">
      <div class="col-lg-12 mb-4">
        <a-input-search
          placeholder="Search Reseller"
          enter-button
          :value="$route.query.q"
          @change="onSearch"
        />
      </div>
      <div class="col-lg-12">
        <div class="card" v-if="!isLoading">
          <div class="card-header">
            <div class="cui__utils__heading mb-0">
              <strong> Reseller List </strong>
            </div>
          </div>
          <div class="card-body">
            <a-table
              :columns="columns"
              :data-source="reseller_list"
              :pagination="false"
              :row-key="data => data.seller_hashid"
              :scroll="{ y: 450 }"
              class="table-reseller"
            >
              <span slot="store_status" slot-scope="store_status" >
                <a-tag
                  :color="store_status === 'pending' ? 'volcano' : 'geekblue'"
                >
                  {{ store_status }}
                </a-tag>
              </span>
              <span slot="actions" slot-scope="text, record">
                <div class="d-flex justify-content-center flex-wrap">
                  <div v-if="record.store_status === 'active'" @click.prevent="openModalLevel(record, 'update')" class="mb-2">
                    <a-button> Update Level </a-button>
                  </div>
                  <div v-if="record.store_status === 'pending'" @click.prevent="openModalLevel(record, 'confirm')" class="mb-2">
                    <a-button> Confirmation Register </a-button>
                  </div>
                  <div class="mb-2">
                    <a-button @click.prevent="() => toDetail(record)"> Detail </a-button>
                  </div>
                </div>
              </span>
            </a-table>
            <a-pagination
              v-if="total > 0"
              :total="total"
              v-model="page"
              :page-size="pageSize"
              @change="page => $router.push({ query: { ...$route.query, page } })"
              class="mt-3 d-flex justify-content-end"
              :show-total="total => `Total ${total} items`"
            />
          </div>
        </div>
      </div>
    </div>
    <a-modal v-model="modalLevelModels" :title="flagModal === 'update' ? 'Update Level Model' : 'Seller Register Confirmation'" :footer="null">
      <ModalLevelModels
        :level_model_id="level_model_id"
        :seller_hashid="seller_hashid"
        :store_status="store_status"
        :flagModal="flagModal"
        @submitLevelModels="submitLevelModels"
      />
    </a-modal>
    <router-view />
  </div>
</template>

<script>
import ModalLevelModels from '@/components/ModalLevelModels'

import { mapState, mapActions } from 'vuex'
import moment from 'moment'

const normalizePage = (value) => {
  if (isNaN(value)) {
    return 1
  }

  const page = Number(value)

  return page < 1 ? 1 : page
}

export default {
  components: {
    ModalLevelModels,
  },
  data() {
    return {
      isSearch: false,
      modalLevelModels: false,
      seller_hashid: null,
      store_status: null,
      level_model_id: null,
      flagModal: null,
      query: this.$route.query,
      total: 0,
      timeout: 0,
      position: {
        x: 0,
        y: 0,
      },
    }
  },
  mounted () {
    this.fetchResellerList()
  },
  methods: {
    ...mapActions('reseller', ['getResellerList', 'searchReseller']),

    toDetail (record) {
      this.position.x = window.scrollX
      this.position.y = window.scrollY

      this.$router.push({
        name: 'profile.detail',
        params: {
          seller_hashid: record.seller_hashid,
        },
        query: {
          ...this.$route.query,
          store_status: record.store_status,
        },
      })
    },

    fetchResellerList () {
      this.$store.dispatch('reseller/getResellerList', {
        ...this.$route.query,
        page: this.page,
        limit: this.pageSize,
      })
        .then(response => {
          this.total = response.rows
        })
    },

    onSearch (e) {
      const value = e.target.value
      if (this.timeout) clearTimeout(this.timeout)

      this.timeout = setTimeout(() => {
        this.$router.push({
          query: {
            ...this.$router.query,
            q: value,
            page: 1,
          },
        })
      }, 1000)
    },
    changeDateFormat (value) {
      return moment(value).format('DD MMMM YYYY')
    },
    openModalLevel (record, flag) {
      this.seller_hashid = record.seller_hashid
      this.store_status = record.store_status
      this.level_model_id = record.level_id
      this.flagModal = flag
      this.modalLevelModels = true
    },
    submitLevelModels () {
      // this.getResellerList()
      this.fetchResellerList()
      this.flagModal = null
      this.seller_hashid = null
      this.store_status = null
      this.level_model_id = null
      this.modalLevelModels = false
    },
  },
  computed: {
    ...mapState('reseller', {
      isLoading: state => state.isLoading,
      reseller_list: state => state.reseller_list,
      search: state => state.search,
      columns: state => state.columns,
    }),

    page () {
      return normalizePage(this.$route.query.page)
    },

    pageSize () {
      return Number(this.$route.query.pageSize) || 30
    },
  },
  watch: {
    '$route.query.q'(val) {
      this.fetchResellerList()
    },
    '$route.query.page'(val) {
      this.fetchResellerList()
    },
    '$route.query.pageSize'(val) {
      this.fetchResellerList()
    },
  },
}
</script>

<style lang="scss">
.table-reseller {
  tr {
    > th {
      padding: 10px !important;
      font-weight: bold !important;
    }
  }
}
</style>
